import React from 'react'
import { connect } from 'react-redux'
import '../../../css/components/react-datepicker.css';
import Titulo from '../../comum/Titulo';
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
import buscarFechamentosCaixa from '../../../actions/fechamento-caixa/agencia/buscarFechamentosCaixaAgencia';
import limparFechamentosCaixa from '../../../actions/fechamento-caixa/limparFechamentosCaixa';
import Autorizacao from '../../../security/Autorizacao';
import {
  getAdminEmpresa,
  getFinanceiroAgencia, getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import CampoSelecionarEmpresa from '../../layout/CampoSelecionarEmpresa';
import FechamentoCaixaAgencia from './FechamentoCaixaAgencia';
import ModalFechamentoCaixaAgencia from './ModalFechamentoCaixaAgencia';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import PaginacaoFechamentoCaixa from '../PaginacaoFechamentoCaixa';
import BotoesPaginacaoFechamentoCaixa from '../BotoesPaginacaoFechamentoCaixa';
import { alterouFiltro, alterouPagina } from '../../../util/filtros';
import determinarPaginaAtual from '../../../actions/fechamento-caixa/determinarPaginaAtuaFechamentoCaixa';
import PainelFiltragem from './PainelFiltrosFechamentoCaixa';
import limparFiltroFechamentoCaixa from '../../../actions/fechamento-caixa/limparFiltroFechamentoCaixa';


export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Data</div>
      <div className="col-lg-3 col-xl-3 d-sm-none d-none d-md-block">Agência</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Quantidade de vendas</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Valor total de vendas</div>
      <div className="col-lg-2 col-xl-2 d-sm-none d-none d-md-block">Situacão</div>
    </div>
  </div>
);


export class PainelFechamentoCaixaAgencia extends React.Component {
  constructor (props) {
    super(props);
    this.limparCampos = this.limparCampos.bind(this);
    this.state = {
      dataSelecionada: null,
      itemFechamentoSelecionado: null
    };
  }

  limparCampos() {
    this.props.limparFechamentosCaixa();
    this.props.limparFiltroFechamentoCaixa();
  }

  selecionarItemFechamento (item) {
    this.setState({
      itemFechamentoSelecionado: item
    });
  }

  componentDidMount () {
    this.limparCampos();
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.buscarFechamentos();
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.buscarFechamentos();
      if (!alterouPagina(this.props, prevProps)) {
        this.props.determinarPaginaAtual(1)
      }
    }
  }

  exibirTabela () {
    if ((this.props.fechamentosCaixa && this.props.fechamentosCaixa.length)) {
      return (<div id='tabela-pedidos'>
          <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoFechamentoCaixa}
                                 BotoesPaginacao={BotoesPaginacaoFechamentoCaixa}
                                 pedidos={this.props.pedidos}
                                 empresaSelecionada={this.props.empresaSelecionada}>
            <CabecalhoTabela idEmpresa={this.props.empresaSelecionada.id}/>
            <div className="lista-table">
              {this.exibirFechamento()}
            </div>
          </CabecalhoRodapeTabela>

        </div>
      )
    }
    return <div className="alert alert-warning text-center" role="alert">
      Não foi encontrado resultado para sua pesquisa.
    </div>;
  }

  exibirFechamento () {
    if (this.props.fechamentosCaixa && this.props.fechamentosCaixa.length) {
      return <div className="geral">{this.props.fechamentosCaixa.map(fechamento => <FechamentoCaixaAgencia key={fechamento.id} fechamento={fechamento}/>)}</div>
    }
  }


  buscarFechamentos () {
    this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
  }


  exibirCampoBuscaEmpresa () {
    return (<React.Fragment>
      <div className='row mb-4'>
        <div className="col-md-8">
          <CampoSelecionarEmpresa/>
        </div>
      </div>
    </React.Fragment>)
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroAgencia(this.props.empresaSelecionada.id),
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getFinanceiroCaixa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        PERFIL_ADMIN]}
        empresaSelecionada={this.props.empresaSelecionada}>
        <div className="row internas">
          <Titulo texto="Fechamento de Caixa (Agência)" urlRetorno="/menu-fechamento-caixa"/>
          <div className="col-12 filtro-busca">
            <PainelFiltragem/>
          </div>
          <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
              {this.exibirCampoBuscaEmpresa()}
            </Autorizacao>
            <div className="lista-table">
              {this.exibirTabela()}
            </div>
          </div>
        </div>
        <ModalFechamentoCaixaAgencia data={this.state.dataSelecionada} buscaFechamentos={this.buscarFechamentos.bind(this)}/>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    fechamentosCaixa: state.fechamentosCaixa.fechamentos ? state.fechamentosCaixa.fechamentos : '',
    empresaSelecionada: state.empresaSelecionada ? state.empresaSelecionada : '',
    filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa ? state.filtrosAdicionadosFechamentoCaixa : '',
    paginaAtual: state.paginaAtualFechamentoCaixa ? state.paginaAtualFechamentoCaixa : '',
    registrosPorPagina: state.registrosPorPaginaFechamentoCaixa ? state.registrosPorPaginaFechamentoCaixa : ''
  });


export default connect(mapStateToProps,
  {
    buscarFechamentosCaixa,
    limparFechamentosCaixa,
    limparFiltroFechamentoCaixa,
    determinarPaginaAtual
  })(PainelFechamentoCaixaAgencia)
